import HTTP from "../utils/httpClient";
import * as types from "../types/issuerType";
import { toastr } from "react-redux-toastr";
import { reactReduxToastrOptions } from "../constants/helper";
import { asyncActionStart, asyncActionFinish } from "./../asyncLoading/AsyncAction";

const config = {
    headers: {
        "Content-Type": "application/json"
    }
};

export const getIssuers =
    (params, loading = true) =>
    async (dispatch) => {
        try {
            if (loading) dispatch(asyncActionStart());
            const res = await HTTP.get(`/api/v1/issuer/`, {
                params: {
                    size: 200,
                    ...params
                }
            });
            dispatch({
                type: types.GET_ISSUERS,
                payload: res.data.data.content
            });
            dispatch(asyncActionFinish());
        } catch (err) {
            // console.log(err)
        }
    };

export const getPersistedIssuers = () => async (dispatch) => {
    try {
        const res = await HTTP.get(`/api/v1/issuer/`, {
            params: {
                size: 0
            }
        });
        dispatch({
            type: types.GET_PERSISTED_ISSUERS,
            payload: res.data.data.content
        });
    } catch (err) {
        // console.log(err)
    }
};

export const getIssuerById = (id) => {
    return HTTP.get(`/api/v1/issuer/`, {
        params: {
            issuerId: id
        }
    });
};

export const addIssuer = (dataObj) => {
    return HTTP.post(`/api/v1/issuer/`, dataObj, config);
};

export const updateIssuer = (dataObj, id) => {
    return HTTP.put(`/api/v1/issuer/${id}`, dataObj, config);
};

export const postIssuer = (dataObj) => {
    return (dispatch) => {
        HTTP.post(`/api/v1/issuer/`, dataObj, config)
            .then((_response) => {
                // console.log(response)
                dispatch({
                    type: types.ADD_ISSUER
                });
                toastr.success(
                    "ISSUER",
                    `Successfully Processed`,
                    reactReduxToastrOptions("bottom-right")
                );
                dispatch(getIssuers());
            })
            .catch((_err) => {
                // console.log(err)
            });
    };
};
